var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 2H7C4.23858 2 2 4.23858 2 7V17C2 19.7614 4.23858 22 7 22H17C19.7614 22 22 19.7614 22 17V7C22 4.23858 19.7614 2 17 2Z",
    stroke: "#28245C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 11.3664C16.1231 12.1986 15.981 13.0486 15.5935 13.7954C15.206 14.5422 14.5929 15.1478 13.8413 15.5261C13.0898 15.9043 12.2382 16.036 11.4075 15.9023C10.5768 15.7687 9.80947 15.3765 9.21455 14.7816C8.61962 14.1866 8.22744 13.4193 8.09377 12.5886C7.96011 11.7579 8.09177 10.9063 8.47003 10.1548C8.84829 9.40325 9.45389 8.79014 10.2007 8.40264C10.9475 8.01514 11.7975 7.87298 12.6297 7.9964C13.4786 8.12228 14.2646 8.51786 14.8714 9.1247C15.4782 9.73154 15.8738 10.5175 15.9997 11.3664Z",
    stroke: "#28245C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 6.5H17.51",
    stroke: "#28245C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramBlue);
export default __webpack_public_path__ + "static/media/instagram-blue.aa3e06a601a1072f9d9a31ff4c4e5105.svg";
export { ForwardRef as ReactComponent };